import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const ServiceCard = ({ 
  number, 
  title, 
  subtitle, 
  description, 
  frequency,
  href 
}) => {
  return (
    <Link 
      to={href} 
      className="service-card group"
      data-testid={`service-card-${title.toLowerCase()}`}
    >
      <div className="flex-1">
        <span className="label-mono mb-4 block">
          {number}
        </span>
        
        <h3 className="font-serif text-2xl md:text-3xl text-[#1A1A1A] mb-2">
          {title}
        </h3>
        
        <p className="font-mono text-xs uppercase tracking-widest text-[#5A5A5A] mb-4">
          {subtitle}
        </p>
        
        <p className="body-text mb-6">
          {description}
        </p>

        {frequency && (
          <p className="text-sm text-[#5A5A5A]">
            {frequency}
          </p>
        )}
      </div>

      <div className="flex items-center gap-2 mt-6 text-[#1A1A1A] opacity-0 group-hover:opacity-100 transition-opacity">
        <span className="text-sm font-medium">Saber mais</span>
        <ArrowRight size={16} />
      </div>
    </Link>
  );
};
